import axios from '@/api/tool'


/**
 * 加减项目列表
 */
export function projectManagementGet() {
  return axios({
    url: '/projectManagement/get',
    method: 'get'
  })
}
/**
 * 固定资产列表
 */
export function fixedAssetsManagementQueryAllEquipment(data) {
  return axios({
    url: '/fixedAssetsManagement/queryAllEquipment',
    method: 'post',
    data: data
  })
}

/**
 * 查询固定资产
 * @param id
 */
export function fixedAssetsManagementQuery(id) {
  return axios({
    url: '/fixedAssetsManagement/query/' + id,
    method: 'get'
  })
}
/**
 * 新增修改固定资产
 * @param data
 */
export function fixedAssetsManagementSaveEquipment(data) {
  return axios({
    url: '/fixedAssetsManagement/saveEquipment',
    method: 'post',
    data: data
  })
}

/**
 * 删除固定资产
 * @param data
 */
export function fixedAssetsManagementDeleteEquipment(data) {
  return axios({
    url: '/fixedAssetsManagement/deleteEquipment',
    method: 'post',
    data: data
  })
}

/**
 * 无形资产列表
 * @param data
 */
export function intangibleAssetsManagementQueryAll(data) {
  return axios({
    url: '/intangibleAssetsManagement/queryAll',
    method: 'post',
    data: data
  })
}

/**
 * 查询无形资产
 * @param id
 */
export function intangibleAssetsManagementQuery(id) {
  return axios({
    url: '/intangibleAssetsManagement/query/' + id,
    method: 'get'
  })
}

/**
 * 新增修改无形资产
 * @param data
 */
export function intangibleAssetsManagementSave(data) {
  return axios({
    url: '/intangibleAssetsManagement/save',
    method: 'post',
    data: data
  })
}

/**
 * 删除无形
 * @param data
 */
export function intangibleAssetsManagementDelete(data) {
  return axios({
    url: '/intangibleAssetsManagement/delete',
    method: 'post',
    data: data
  })
}

/**
 * 资本化管理列表
 * @param data
 */
export function capitalizationManagementQueryAll(data) {
  return axios({
    url: '/capitalizationManagement/queryAll',
    method: 'post',
    data: data
  })
}

/**
 * 查询资本化管理
 * @param id
 */
export function capitalizationManagementQuery(id) {
  return axios({
    url: '/capitalizationManagement/query/' + id,
    method: 'get'
  })
}

/**
 * 新增修改资本化管理
 * @param data
 */
export function capitalizationManagementSave(data) {
  return axios({
    url: '/capitalizationManagement/save',
    method: 'post',
    data: data
  })
}

/**
 * 删除资本化管理
 * @param data
 */
export function capitalizationManagementDelete(data) {
  return axios({
    url: '/capitalizationManagement/delete',
    method: 'post',
    data: data
  })
}

/**
 * 材料管理列表
 * @param data
 */
export function materialManagementQueryAll(data) {
  return axios({
    url: '/materialManagement/queryAll',
    method: 'post',
    data: data
  })
}

/**
 * 查询材料管理
 * @param id
 */
export function materialManagementQuery(id) {
  return axios({
    url: '/materialManagement/query/' + id,
    method: 'get'
  })
}

/**
 * 新增修改材料管理
 * @param data
 */
export function materialManagementSave(data) {
  return axios({
    url: '/materialManagement/save',
    method: 'post',
    data: data
  })
}

/**
 * 删除材料管理
 * @param data
 */
export function materialManagementDelete(data) {
  return axios({
    url: '/materialManagement/delete',
    method: 'post',
    data: data
  })
}

/**
 * 燃料管理列表
 * @param data
 */
export function fuelManagementQueryAll(data) {
  return axios({
    url: '/fuelManagement/queryAll',
    method: 'post',
    data: data
  })
}

/**
 * 查询燃料管理
 * @param id
 */
export function fuelManagementQuery(id) {
  return axios({
    url: '/fuelManagement/query/' + id,
    method: 'get'
  })
}

/**
 * 新增修改燃料管理
 * @param data
 */
export function fuelManagementSave(data) {
  return axios({
    url: '/fuelManagement/save',
    method: 'post',
    data: data
  })
}

/**
 * 删除燃料管理
 * @param data
 */
export function fuelManagementDelete(data) {
  return axios({
    url: '/fuelManagement/delete',
    method: 'post',
    data: data
  })
}

/**
 * 动力管理列表
 * @param data
 */
export function powerManagementQueryAll(data) {
  return axios({
    url: '/powerManagement/queryAll',
    method: 'post',
    data: data
  })
}

/**
 * 查询动力管理
 * @param id
 */
export function powerManagementQuery(id) {
  return axios({
    url: '/powerManagement/query/' + id,
    method: 'get'
  })
}

/**
 * 新增修改动力管理
 * @param data
 */
export function powerManagementSave(data) {
  return axios({
    url: '/powerManagement/save',
    method: 'post',
    data: data
  })
}

/**
 * 删除动力管理
 * @param data
 */
export function powerManagementDelete(data) {
  return axios({
    url: '/powerManagement/delete',
    method: 'post',
    data: data
  })
}

/**
 * 凭证管理列表
 * @param data
 */
export function vouchertQuery(data) {
  return axios({
    url: '/voucher/query',
    method: 'post',
    data: data
  })
}

/**
 * 查询凭证管理
 * @param id
 */
export function voucherQueryOne(id) {
  return axios({
    url: '/voucher/queryOne/' + id,
    method: 'get'
  })
}

/**
 * 新增凭证管理
 * @param data
 */
export function voucherAdd(data) {
  return axios({
    url: '/voucher/add',
    method: 'post',
    data: data
  })
}

/**
 * 修改凭证管理
 * @param data
 */
export function voucherUpdate(data) {
  return axios({
    url: '/voucher/update',
    method: 'post',
    data: data
  })
}

/**
 * 删除凭证管理
 * @param data
 */
export function voucherDelete(data) {
  return axios({
    url: '/voucher/delete',
    method: 'post',
    data: data
  })
}

/**
 * 凭证科目
 */
export function voucherQuerySubjects() {
  return axios({
    url: '/voucher/querySubjects',
    method: 'get'
  })
}

/**
 * 财务下载模板
 * @param templateCode
 */
export function importDateDownloadTemplate(templateCode) {
  return axios({
    url: '/importDate/downloadTemplate/' + templateCode,
    method: 'get'
  })
}
